import React from 'react';
import { useTranslations } from 'next-intl';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';
import { DeprecatedIcon } from '@mentimeter/ragnar-visuals/slide-type-icons';

export function DeprecatedPresentation() {
  const t = useTranslations('presenting');
  return (
    <Box
      width="100%"
      height="100%"
      alignItems="center"
      justifyContent="center"
      p={4}
    >
      <DeprecatedIcon size={100} />
      <Text mt={2} textAlign="center" color="text" fontSize={40}>
        {t('deprecated_slide_type_message')}
      </Text>
    </Box>
  );
}
